import axios from "axios";
import { endpointUrl } from "../../../services/connection";

export async function getPackageByPeriod(period: string) {
  const response = await axios
    .get(`${endpointUrl}/pricing/get-packages/${period}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getPackageOffers(id: number) {
  const response = await axios
    .get(`${endpointUrl}/pricing/get-package-offers/${id}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getPackagePlanDetails(id: number) {
  const response = await axios
    .get(`${endpointUrl}/pricing/get-package-plan-details/${id}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getPackageFeatures(id: number) {
  const response = await axios
    .get(`${endpointUrl}/pricing/get-package-features/${id}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createNewPassword(
  passwordResetToken: any,
  password: string,
  email: string
) {
  const data = {
    password1: password,
    password2: password,
    token: passwordResetToken,
    email,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/set_new_password`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createPaymentIntent(
  email: string,
  firstName: string,
  surname: string,
  packageId: any,
  saveCard: boolean,
  paymentMethod: any
) {
  const data = {
    email,
    firstName,
    surname,
    packageId,
    saveCard,
    paymentMethod,
  };
  const response = await axios
    .post(`${endpointUrl}/pricing/create/stripe/payment-intent`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createSetupIntent(email: string) {
  const data = {
    email,
  };
  const response = await axios
    .post(`${endpointUrl}/pricing/create/stripe/setup-intent`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function makeDefaultCard(token: string, cardInformation: {}) {
  const response = await axios
    .post(`${endpointUrl}/pricing/make-default-card`, cardInformation, {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res);

  return response;
}

export async function downgrade(token: string, tenantInformation: {}) {
  const response = await axios
    .post(`${endpointUrl}/pricing/downgrade`, tenantInformation, {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res);

  return response;
}

export async function cancelDowngrade(token: string) {
  const response = await axios
    .post(
      `${endpointUrl}/pricing/cancel-downgrade`,
      {},
      {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res);

  return response;
}

export async function retrieveUsersCards(stripeId: string) {
  const response = await axios
    .get(`${endpointUrl}/pricing/retrieve-cards/${stripeId}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function removeCard(cardId: string) {
  const response = await axios
    .post(`${endpointUrl}/pricing/remove-card/${cardId}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function replaceCard(cardId: string, token: string) {
  const data = {
    card_id: cardId,
  };
  const response = await axios
    .post(`${endpointUrl}/pricing/replace-card`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getBillingHistory(tenant_id: any) {
  const response = await axios
    .get(
      `${endpointUrl}/user-account/get-tenant-billing-history/${tenant_id}`,
      {}
    )
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function triggerAutoPay(email: any) {
  const response = await axios
    .get(`${endpointUrl}/pricing/trigger-auto-pay/${email}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getCouponCode(code: string) {
  const response = await axios
    .get(`${endpointUrl}/pricing/coupon-code/${code}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getTenantCouponCode(code: string, email: string) {
  const response = await axios
    .get(`${endpointUrl}/pricing/tenant-coupon-code/${code}/${email}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function handleSuccessfulCouponPayment(
  email: string,
  code: string
) {
  const response = await axios
    .get(`${endpointUrl}/pricing/handle-100-coupon/${email}/${code}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}
